exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#criteriaButtons{margin:10px}#selectOperator{margin:20px}.card-title{margin-bottom:40px;text-align:left;margin-top:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ceb765c2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search/GrammaticalSearch.vue
// module id = 1145
// module chunks = 0